import React, { MouseEvent, ChangeEvent } from 'react';
import { TextField, InputAdornment, Button, withStyles } from '@material-ui/core';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import classNames from 'classnames';
import { useStyles } from './cardapio-header-busca-style';

export interface CardapioHeaderBuscaProps {
  termoPesquisa?: string;
  className?: string;
  quandoTermoForDigitado?: (event: ChangeEvent<HTMLInputElement>) => any;
  pesquisarClick?: (event: MouseEvent<HTMLButtonElement>) => any;
  referencia?: any;
}

const CssTextField = withStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root': {
      '& input::placeholder': {
        color: theme.palette.text.primary,
        opacity: 0.8,
      },
      '& fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  }, 
}))(TextField);

export const CardapioHeaderBusca = ({
  termoPesquisa,
  pesquisarClick,
  quandoTermoForDigitado,
  className,
  referencia
}: CardapioHeaderBuscaProps) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <CssTextField
        ref={referencia}
        placeholder="Buscar um Produto"
        size="medium"
        margin="none"
        onChange={quandoTermoForDigitado}
        value={termoPesquisa}
        className={[classes.controleBusca, classes.textField].join(' ')}
        InputProps={{
          className: classes.textFieldArea,
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon />
            </InputAdornment>
          ),
        }}
      />
      <Button
        type="button"
        size="large"
        variant="contained"
        color="primary"
        className={[classes.controleBusca, classes.button].join(' ')}
        onClick={pesquisarClick}
      >
        Buscar
      </Button>
    </div>
  );
};
